import React from 'react';
import {Dialog, DialogContent, DialogTitle, DialogDescription} from '@/components/ui/dialog';
import {formatPrice, formatDuration} from '@/lib/format';

export function treatmentBlock(service, rules, cart) {
    const rule = rules[String(service.id)] || {};
    if (cart.some(c => c.service.id === service.id)) return '';
    if ((rule.type === 'addon' || rule.requires?.length) && !cart.some(c => rule.requires?.includes(c.service.id))) {
        return 'This is an add-on treatment. Select a main area treatment first.';
    }
    if (cart.some(c => rule.incompatible?.includes(c.service.id) || rules[String(c.service.id)]?.incompatible?.includes(service.id))) {
        return 'This treatment cannot be booked with your current selections.';
    }
    return '';
}

export function TreatmentDetails({service, rule = {}, blocked = '', selected = false, onClose, onConfirm}) {
    return <Dialog open={Boolean(service)} onOpenChange={open => {if (!open) onClose();}}>
        {service && <DialogContent className="bg-navy text-white border-gold/40 rounded-2xl w-[calc(100%_-_2rem)] max-h-[85dvh] overflow-y-auto p-6">
            <DialogTitle className="font-serif text-2xl pr-6">{service.name}</DialogTitle>
            <DialogDescription className="text-gold">{rule.option_label || (rule.type === 'addon' ? 'Treatment add-on' : 'Main treatment')} · {formatPrice(service.price)} · {formatDuration(service.duration)}</DialogDescription>
            <p className="text-white/85 whitespace-pre-wrap leading-relaxed">{service.description ? service.description.replace(/<br\s*\/?\s*>|<\/p>/gi, '\n').replace(/<[^>]*>/g, '').replace(/\*\*/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&') : 'Please ask Angela if you would like more information about this treatment.'}</p>
            {blocked && <p role="status" className="rounded-xl border border-gold/50 p-3 text-gold">{blocked}</p>}
            <button type="button" disabled={Boolean(blocked) || selected} onClick={onConfirm} className="rounded-full bg-gold text-navy min-h-12 px-5 py-3 font-semibold disabled:opacity-50">{selected ? 'Already selected' : 'Confirm selection'}</button>
            <button type="button" onClick={onClose} className="min-h-11 text-white underline">Back to treatments</button>
        </DialogContent>}
    </Dialog>;
}
